import CloseIcon from '@mui/icons-material/Close';
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from '@mui/material';
import { useEffect, useId } from 'react';

const GeneralUseDialog = ({
  open,
  setOpen,
  contentTitle,
  contentText,
  closeHandler = () => {},
}) => {
  const titleId = useId();
  const descriptionId = useId();

  const handleClose = () => {
    closeHandler();
    setOpen(false);
  };

  useEffect(() => {
    if (!open) return;

    // MUI's focus trap inserts sentinel divs with tabIndex=0.
    // Some scanners flag these unless they expose a role (and/or are aria-hidden).
    const sentinels = document.querySelectorAll(
      '[data-testid="sentinelStart"], [data-testid="sentinelEnd"]'
    );

    sentinels.forEach((el) => {
      if (!el.getAttribute('role')) el.setAttribute('role', 'presentation');
      if (el.getAttribute('aria-hidden') !== 'true')
        el.setAttribute('aria-hidden', 'true');
    });
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth='sm'
      fullWidth={true}
      aria-labelledby={titleId}
      aria-describedby={descriptionId}
    >
      <DialogTitle component='h2' id={titleId}>
        {contentTitle}
        <IconButton
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
          }}
          aria-label='close dialog'
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id={descriptionId} component='p'>
          {contentText}
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default GeneralUseDialog;
